import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { BOX_NOTECARD_STEPS } from '../../../../../redux/box-notecard-editor/box-notecard-editor.reducer';
import { moveToPopupStep, submitBoxNotecard } from '../../../../../redux/box-notecard-editor/box-notecard-editor.actions';
import { updateNotecardTextContent } from '../../../../../redux/notecard-editor/notecard-editor.actions';
import { notecardColorSelector, notecardLogoPreviewSelector, notecardTextContentSelector } from '../../../../../redux/notecard-editor/notecard-editor.selectors';
import { isLoadingSelector } from '../../../../../redux/box-notecard-editor/box-notecard-editor.selectors';
import { TextEditorStepComponent } from './text-editor-step';
const mapStateToProps = createStructuredSelector({
  color: notecardColorSelector,
  logo: notecardLogoPreviewSelector,
  textContent: notecardTextContentSelector,
  isLoading: isLoadingSelector
});
const mapDispatchToProps = dispatch => ({
  onNext: mockupContainer => {
    dispatch(submitBoxNotecard(mockupContainer));
  },
  onBack: () => {
    dispatch(moveToPopupStep(BOX_NOTECARD_STEPS.LOGO_AND_COLOR));
  },
  handleNotecardTextContentChange: html => {
    dispatch(updateNotecardTextContent(html));
  }
});
export const TextEditorStep = connect(mapStateToProps, mapDispatchToProps)(TextEditorStepComponent);